export function BuildingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/building.svg'"></ng-include>`
    }
}